import React, { useEffect, useMemo, useState } from "react";
import style from "./index.module.scss";
import { Table, Tooltip } from "antd";
import { ColumnProps } from "antd/es/table";
import { strCut } from "utils/common";
import { LearningInfo, studyPageLine } from "service/report";

interface StudyAnalyseProps {
    data: LearningInfo[];
    onsorter: (value: string) => void;
}
// export default function StudyAnalyse({ data }: StudyAnalyseProps) {
export default function StudyAnalyse(props: StudyAnalyseProps) {
    const [list, setList] = useState<LearningInfo[]>([]);
    const [oneData] = useState({
        studentNo: "",
        studentName: "",
        department: "",
        subject: "",
        className: "",
        coursewarePublishCount: "",
        studyCoursewareCount: "",
        signInCount: "",
        signInNormalCount: "",
        signInLateCount: "",
        signInEarlyCount: "",
        signAskForLeaveCount: "",
        votePaperCount: "",
        votePaperJoinCount: "",
        paperCount: "",
        paperJoinCount: "",
        paperAveScore: "",
        exerciseCount: "",
        exerciseJoinCount: "",
        exerciseAvgCount: "",
        groupTaskCount: "",
        groupTaskParticipation: "",
        groupTaskAvgCount: "",
        markShow: [],
        markOther: ""
    });

    useEffect(() => {
        setList(props.data);
    }, [props.data]);
    const onChange = (pagination: any, filters: any, sorter: any) => {
        props.onsorter(
            sorter.order === "ascend"
                ? "asc"
                : sorter.order === "descend"
                ? "desc"
                : ""
        );
    };
    //学情分析列表项总数达不到页面高度时,用空白行占位
    const newList = useMemo(() => {
        if (list.length < studyPageLine.line) {
            const newArr = new Array(studyPageLine.line - list.length)
                .fill({ ...oneData })
                .map((item, index) => ({ ...item, key: index }));
            return list.concat(newArr);
        }
        return list;
    }, [list]);
    const columns: ColumnProps<LearningInfo>[] = [
        {
            title: "序号",
            dataIndex: "index",
            key: "index",
            width: 70,
            fixed: "left"
        },
        {
            title: "学生信息",
            dataIndex: "studentInfo",
            key: "studentInfo",
            width: 160,
            fixed: "left",
            sorter: (a, b, sorterorder) => {
                if (a.studentInfo?.studentName == undefined) {
                    return sorterorder == "descend" ? -1 : 1;
                } else {
                    return a.studentInfo?.studentName >
                        b.studentInfo?.studentName
                        ? 1
                        : -1;
                }
            },
            render: text => {
                return (
                    <div>
                        <div className={style.columnName}>
                            <Tooltip placement="top" title={text?.studentName}>
                                {text?.studentName}
                            </Tooltip>
                        </div>
                        <div className={style.columnNo}>{text?.studentNo}</div>
                    </div>
                );
            }
        },
        {
            title: "课件",
            children: [
                {
                    title: "发布课件数",
                    dataIndex: "coursewarePublishCount",
                    key: "coursewarePublishCount",
                    width: 86
                },
                {
                    title: "参与数",
                    dataIndex: "studyCoursewareCount",
                    key: "studyCoursewareCount",
                    width: 86
                }
            ]
        },
        {
            title: "签到",
            children: [
                {
                    title: "发布签到数",
                    dataIndex: "signInCount",
                    key: "signInCount",
                    width: 86
                },
                {
                    title: "正常出勤数",
                    dataIndex: "signInNormalCount",
                    key: "signInNormalCount",
                    width: 86
                },
                {
                    title: "迟到数",
                    dataIndex: "signInLateCount",
                    key: "signInLateCount",
                    width: 86
                },
                {
                    title: "早退数",
                    dataIndex: "signInEarlyCount",
                    key: "signInEarlyCount",
                    width: 86
                },
                {
                    title: "请假数",
                    dataIndex: "signAskForLeaveCount",
                    key: "signAskForLeaveCount",
                    width: 86
                }
            ]
        },
        {
            title: "投票",
            children: [
                {
                    title: "发布投票数",
                    dataIndex: "votePaperCount",
                    key: "votePaperCount",
                    width: 86
                },
                {
                    title: "参与数",
                    dataIndex: "votePaperJoinCount",
                    key: "votePaperJoinCount",
                    width: 86
                }
            ]
        },
        {
            title: "选人",
            children: [
                {
                    title: "标签语",
                    dataIndex: "markItem",
                    key: "markItem",
                    width: 300,
                    render: (text: string, record, index) => {
                        return (
                            <div className={style.rollCallContainer}>
                                <Tooltip placement="top" title={text}>
                                    {text
                                        ? strCut(String(record.markItem), 20)
                                        : ""}
                                </Tooltip>
                            </div>
                        );
                    }
                }
            ]
        },
        {
            title: "作业",
            children: [
                {
                    title: "发布作业数",
                    dataIndex: "paperCount",
                    key: "paperCount",
                    width: 86
                },
                {
                    title: "参与数",
                    dataIndex: "paperJoinCount",
                    key: "paperJoinCount",
                    width: 86
                },
                {
                    title: "平均得分(百分制)",
                    dataIndex: "paperAveScore",
                    key: "paperAveScore",
                    width: 130
                }
            ]
        },
        {
            title: "练习",
            children: [
                {
                    title: "发布练习数",
                    dataIndex: "exerciseCount",
                    key: "exerciseCount",
                    width: 100
                },
                {
                    title: "参与数",
                    dataIndex: "exerciseJoinCount",
                    key: "exerciseJoinCount",
                    width: 86
                },
                {
                    title: "平均得分(百分制)",
                    dataIndex: "exerciseAvgCount",
                    key: "exerciseAvgCount",
                    width: 130
                }
            ]
        },
        {
            title: "小组活动",
            children: [
                {
                    title: "发布小组活动数",
                    dataIndex: "groupTaskCount",
                    key: "groupTaskCount",
                    width: 120
                },
                {
                    title: "参与数",
                    dataIndex: "groupTaskParticipation",
                    key: "groupTaskParticipation",
                    width: 86
                },
                {
                    title: "平均得分(百分制)",
                    dataIndex: "groupTaskAvgCount",
                    key: "groupTaskAvgCount",
                    width: 130
                }
            ]
        },
        {
            title: "问卷",
            children: [
                {
                    title: "发布问卷数",
                    dataIndex: "questionnaireCount",
                    key: "questionnaireCount",
                    width: 120
                },
                {
                    title: "问卷参与数",
                    dataIndex: "questionnaireJoinCount",
                    key: "questionnaireJoinCount",
                    width: 86
                }
            ]
        }
    ];

    return (
        <div className={style.root}>
            <Table
                columns={columns}
                dataSource={newList}
                scroll={{ x: 1500 }}
                pagination={false}
                onChange={onChange}
                rowKey="key"
            />
        </div>
    );
}
